import {TArrowIconProps} from "@/app/[locale]/common/assets/ArrowIcon/types";

export const ArrowIcon = ({ active, disabled }: TArrowIconProps) => {
    return (
        <svg width="100%" height="100%" viewBox="0 0 25 25" fill="none" xmlns="http://www.w3.org/2000/svg">
            {
                active ?
                    <>
                        <path
                            d="M17.5765 15.634L18.6365 14.573L12.8595 8.79395C12.7669 8.7008 12.6569 8.62687 12.5356 8.57642C12.4144 8.52597 12.2843 8.5 12.153 8.5C12.0217 8.5 11.8916 8.52597 11.7704 8.57642C11.6491 8.62687 11.5391 8.7008 11.4465 8.79395L5.6665 14.573L6.7265 15.633L12.1515 10.209L17.5765 15.634Z"
                            fill="url(#paint0_linear_239_1078)"/>
                        <defs>
                            <linearGradient id="paint0_linear_239_1078" x1="-1.58144" y1="12.559" x2="15.0366"
                                            y2="31.9082"
                                            gradientUnits="userSpaceOnUse">
                                <stop stopColor="#F83700"/>
                                <stop offset="1" stopColor="#F7CB2A"/>
                            </linearGradient>
                        </defs>
                    </>
                    :
                    <path
                        d="M6.64566 8.86605L5.58566 9.92705L11.3627 15.706C11.4552 15.7992 11.5653 15.8731 11.6866 15.9236C11.8078 15.974 11.9378 16 12.0692 16C12.2005 16 12.3305 15.974 12.4518 15.9236C12.573 15.8731 12.6831 15.7992 12.7757 15.706L18.5557 9.92705L17.4957 8.86705L12.0707 14.291L6.64566 8.86605Z"
                        fill={disabled ? '#EDEDED' : '#1F1F1F'}/>}
        </svg>
    );
};